import without from 'lodash/without';
import cloneDeep from 'lodash/cloneDeep';
import { defineVuexModule } from '../helpers';

export default defineVuexModule({
  namespaced: true,
  state: {
    seatsInCart: [] as any[],
    gaInCart: [] as any[],
    hasGap: false,
  },

  getters: {},

  actions: {
    addSeatToCart(context, seat) {
      context.commit('addSeatToCart', cloneDeep(seat));
    },
    deleteSeatFromCart(context, seat) {
      context.commit('deleteSeatFromCart', seat);
    },
    updateSeatsInCart(context, seats) {
      context.commit('updateSeatsInCart', seats);
    },
    updateGaInCart(context, ga) {
      context.commit('updateGaInCart', ga);
    },
    setHasGap(context, flag: boolean) {
      context.commit('setHasGap', flag);
    },
  },

  mutations: {
    addSeatToCart(state, seat) {
      state.seatsInCart = [...state.seatsInCart, seat];
    },
    deleteSeatFromCart(state, seat) {
      state.seatsInCart = without(state.seatsInCart, seat);
    },
    updateSeatsInCart(state, seats) {
      state.seatsInCart = [];
      state.seatsInCart = seats;
    },
    updateGaInCart(state, ga) {
      let gaForEdit = null;
      if (state.gaInCart && state.gaInCart.length > 0) {
        gaForEdit = state.gaInCart.find((g) => g.uuid === ga.uuid);
      }
      if (!gaForEdit) {
        if (ga.count === 0) {
          return;
        }
        state.gaInCart = [...state.gaInCart, cloneDeep(ga)];
      } else {
        if (ga.count === 0) {
          state.gaInCart = without(state.gaInCart, gaForEdit);
          return;
        }
        gaForEdit.count = ga.count;
      }
    },
    setHasGap(state, flag: boolean) {
      state.hasGap = flag;
    },
  },
});
